module.exports = {
	"ha": "vcha",
	"id": 5.3,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by Age Category, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 70.2247191011236,
						"dataLabels": {
							"enabled": true,
							"format": "125",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 66.29213483146067,
						"dataLabels": {
							"enabled": true,
							"format": "118",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 64.04494382022472,
						"dataLabels": {
							"enabled": true,
							"format": "114",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 57.30337078651685,
						"dataLabels": {
							"enabled": true,
							"format": "102",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 47.19101123595505,
						"dataLabels": {
							"enabled": true,
							"format": "84",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 94.73684210526315,
						"dataLabels": {
							"enabled": true,
							"format": "540",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 85.96491228070175,
						"dataLabels": {
							"enabled": true,
							"format": "490",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 82.98245614035088,
						"dataLabels": {
							"enabled": true,
							"format": "473",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.15789473684211,
						"dataLabels": {
							"enabled": true,
							"format": "417",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 59.64912280701754,
						"dataLabels": {
							"enabled": true,
							"format": "340",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 97.35894357743096,
						"dataLabels": {
							"enabled": true,
							"format": "811",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 86.91476590636255,
						"dataLabels": {
							"enabled": true,
							"format": "724",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.51380552220888,
						"dataLabels": {
							"enabled": true,
							"format": "704",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 76.95078031212485,
						"dataLabels": {
							"enabled": true,
							"format": "641",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 62.064825930372145,
						"dataLabels": {
							"enabled": true,
							"format": "517",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.58538228359717,
						"dataLabels": {
							"enabled": true,
							"format": "2927",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 88.8514651397777,
						"dataLabels": {
							"enabled": true,
							"format": "2638",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 86.32536207477266,
						"dataLabels": {
							"enabled": true,
							"format": "2563",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 82.62041091276524,
						"dataLabels": {
							"enabled": true,
							"format": "2453",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 70.66352307174132,
						"dataLabels": {
							"enabled": true,
							"format": "2098",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -29.7752808988764,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.600000000000005,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.3898305084745783,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.526315789473683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.647058823529417,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.259259259259256,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.469387755102038,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.839323467230445,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.4652278177458,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -2.6410564225690325,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.727496917385949,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -2.7624309392265234,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.948863636363635,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -19.344773790951642,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.4146177164028328,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.873590707208745,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -2.8430629264594387,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.29184549356223,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.472075010191599,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=178"
			},
			{
				"x": 9,
				"text": "30–39<br>n=570"
			},
			{
				"x": 15,
				"text": "40–49<br>n=833"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=2969"
			}
		],
		"dataTable": {
			"< 30": [
				178,
				125,
				118,
				114,
				102,
				84
			],
			"30–39": [
				570,
				540,
				490,
				473,
				417,
				340
			],
			"40–49": [
				833,
				811,
				724,
				704,
				641,
				517
			],
			"≥ 50": [
				2969,
				2927,
				2638,
				2563,
				2453,
				2098
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_3.json
// module id = 304
// module chunks = 0